import React from 'react';
import { MapPin, Clock, Phone } from 'lucide-react';
export function Location() {
  return <section id="contact" className="bg-slate-50 py-24" data-id="element-103">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-104">
        <div className="bg-white rounded-2xl shadow-xl overflow-hidden" data-id="element-105">
          <div className="grid grid-cols-1 lg:grid-cols-2" data-id="element-106">
            {/* Contact Info */}
            <div className="p-8 md:p-12 lg:p-16 bg-blue-900 text-white" data-id="element-107">
              <h2 className="text-3xl font-bold mb-8" data-id="element-108">Visit Our Store</h2>

              <div className="space-y-8" data-id="element-109">
                <div className="flex items-start" data-id="element-110">
                  <MapPin className="h-6 w-6 text-teal-400 mt-1 mr-4 flex-shrink-0" data-id="element-111" />
                  <div data-id="element-112">
                    <h3 className="text-lg font-semibold text-white" data-id="element-113">
                      Address
                    </h3>
                    <p className="text-blue-100 mt-1" data-id="element-114">
                      Aliyu Makama Road, Barnawa
                      <br data-id="element-115" />
                      Kaduna 800282
                      <br data-id="element-116" />
                      Kaduna, Nigeria
                    </p>
                    <p className="text-sm text-teal-400 mt-2 font-mono" data-id="element-117">
                      Plus Code: FCFM+8G Kaduna
                    </p>
                  </div>
                </div>

                <div className="flex items-start" data-id="element-118">
                  <Clock className="h-6 w-6 text-teal-400 mt-1 mr-4 flex-shrink-0" data-id="element-119" />
                  <div data-id="element-120">
                    <h3 className="text-lg font-semibold text-white" data-id="element-121">
                      Operating Hours
                    </h3>
                    <p className="text-blue-100 mt-1" data-id="element-122">
                      Open Daily
                      <br data-id="element-123" />
                      Closes at 8:00 PM
                    </p>
                  </div>
                </div>

                <div className="flex items-start" data-id="element-124">
                  <Phone className="h-6 w-6 text-teal-400 mt-1 mr-4 flex-shrink-0" data-id="element-125" />
                  <div data-id="element-126">
                    <h3 className="text-lg font-semibold text-white" data-id="element-127">Phone</h3>
                    <a href="tel:08035856111" className="text-blue-100 hover:text-white transition-colors text-lg font-medium mt-1 block" data-id="element-128">
                      0803 585 6111
                    </a>
                    <p className="text-sm text-blue-200 mt-2" data-id="element-129">
                      Call us or message on WhatsApp
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Map Placeholder */}
            <div className="relative h-96 lg:h-auto bg-slate-200" data-id="element-130">
              {/* In a real app, this would be a Google Maps embed */}
              <div className="absolute inset-0 flex items-center justify-center bg-slate-200" data-id="element-131">
                <div className="text-center p-6" data-id="element-132">
                  <MapPin className="h-12 w-12 text-slate-400 mx-auto mb-4" data-id="element-133" />
                  <p className="text-slate-500 font-medium text-lg" data-id="element-134">
                    Map Location
                  </p>
                  <p className="text-slate-400" data-id="element-135">Aliyu Makama Road, Barnawa</p>
                  <a href="https://www.google.com/maps/search/?api=1&query=Gauchos+Frozen+Food+Kaduna" target="_blank" rel="noopener noreferrer" className="inline-block mt-4 text-blue-600 hover:text-blue-800 font-medium underline" data-id="element-136">
                    View on Google Maps
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}